import $ from "jquery";

export default () => {
    function scrollToAnchor(target) {
		if (target.length) {
			console.log("Scrolling to target:", target);
			$('html, body').animate({
				scrollTop: target.offset().top - 100
			}, 500); 
    	}
	}
  	
	var hash = window.location.hash;

	if (hash) {
		var target = $(hash);
		scrollToAnchor(target);
	}
	
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		var target = $($(this).attr('href'));
		scrollToAnchor(target);
	});
};